import React from 'react';

export default function Add(props) {
  return (
    <svg preserveAspectRatio="xMidYMid" viewBox="0 0 24 24" {...props}>
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/add.js